import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Smart from 'components/Smart';
import { Refresh } from 'components/Pagination';
import {
    REFUND_BY_MONEY,
    PAYMENT_STATUS_SUCCESS,
    PAYMENT_STATUS_FAIL,
    PAYMENT_CHANNEL_TAPPAY,
    REFUND_ERROR_CHARGE_PROCESSING,
    REFUND_ERROR_CHARGE_DUPLICATE,
    REFUND_ERROR_INVOICE_ISSUING,
} from 'constants/rental';
import AuthView from 'components/AuthView';
import NavigationBar from 'components/NavigationBar';
import FlexGroup from 'components/FlexGroup';
import ConfirmModal from 'components/ConfirmModal';
import {
    updateDocumentTitle,
    fetchRentalDetail,
    clearRentalDetail,
    refund,
    updateSubtotal,
    toggleErrorDialog,
} from 'actions';
import { I18n, Translate } from 'react-redux-i18n';
import DetailsSection from './FormSection/Details';
import RefundModal from './FormSection/RefundModal';
import ChangeAmountModal from './FormSection/ChangeAmountModal';
import FunctionButtons from './FormSection/FunctionButtons';
import './rental-detail.scss';

class RentalDetail extends React.Component {
    static propTypes = {
        detail: ImmutablePropTypes.map,
    };

    static defaultProps = {
        detail: undefined,
    };

    constructor(props) {
        super(props);

        const { match } = props;
        this.state = {
            showRefundModal: false,
            showRefundConfirmModal: false,
            showChangeAmountModal: false,
            showChangeAmountConfirmModal: false,
            refundType: REFUND_BY_MONEY,
            refundValue: 0,
            newAmount: 0,
        };
        this.elForm = React.createRef();
        this.rentalId = match.params.rentalId;
        this.queryPayload = {
            id: this.rentalId,
            price: undefined,
            coupon_id: undefined,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(updateDocumentTitle('rental.rental_detail'));
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(clearRentalDetail());
    }

    fetchData = () => {
        const { dispatch } = this.props;
        return dispatch(fetchRentalDetail(this.rentalId));
    }

    dispatchRefund = (payload) => {
        const { dispatch, detail } = this.props;
        const { payment_channel } = (detail && detail.toJS()) || {};
        return dispatch(refund(payload)).then(
            ({ type, error }) => {
                if (type === 'ERROR') {
                    const { code } = error.response.data;
                    let message = (payment_channel === PAYMENT_CHANNEL_TAPPAY) ?
                        I18n.t('rental.refund_failed', {
                        code,
                    }) : I18n.t('rental.refund_failed_go_rewards');

                    if (300004 === code) {
                        message = I18n.t('rental.partial_refund_failed');
                    }

                    if (code === REFUND_ERROR_CHARGE_PROCESSING) {
                        message = I18n.t('rental.refund_error_charge_processing');
                    }

                    if (code === REFUND_ERROR_CHARGE_DUPLICATE) {
                        message = I18n.t('rental.refund_error_charge_duplicate');
                    }

                    if (code === REFUND_ERROR_INVOICE_ISSUING) {
                        message = I18n.t('rental.refund_error_invoice_issuing');
                    }

                    dispatch(toggleErrorDialog(message));
                    this.setState({
                        showRefundConfirmModal: false,
                    });
                }
                else {
                    this.setState({
                        showRefundConfirmModal: false,
                        showRefundModal: false,
                    });
                }
            }
        );
    }

    handleRefundSubmit = (value, type) => {
        if (type === REFUND_BY_MONEY) {
            this.setState({
                showRefundConfirmModal: true,
                refundValue: value
            });
        }
        else {
            return this.dispatchRefund({
                id: this.rentalId,
                ...value,
            });
        }
    }

    handleRefundConfirmSubmit = (value) => {
        return this.dispatchRefund({
            id: this.rentalId,
            price: Number(value),
        });
    }

    handleChangeAmountWarning = (value) => {
        this.setState({
            showChangeAmountConfirmModal: true,
            newAmount: value
        });
    }

    handleChangeAmount = (value) => {
        const { dispatch } = this.props;
        return dispatch(updateSubtotal({
            id: this.rentalId,
            amount: value,
        })).then(
            ({ type, error }) => {
                if (type === 'ERROR') {
                    const { code } = error.response.data;
                    const message = I18n.t('rental.chagne_amount_failed', {
                        code,
                    });

                    dispatch(toggleErrorDialog(message));
                    this.setState({
                        showChangeAmountConfirmModal: false,
                    });
                }
                else {
                    this.setState({
                        showChangeAmountModal: false,
                        showChangeAmountConfirmModal: false,
                    });
                }
            }
        );
    }

    handleRefundTypeSelect = type => {
        this.setState({
            showRefundModal: true,
            refundType: type,
        });
    }

    render() {
        const {
            showRefundModal,
            showRefundConfirmModal,
            showChangeAmountModal,
            showChangeAmountConfirmModal,
            refundType,
            refundValue,
            newAmount,
        } = this.state;
        const { detail } = this.props;
        const rentalDetail = (detail && detail.toJS()) || {};
        const refunded = typeof rentalDetail.refund_price === 'number' ||
            typeof rentalDetail.refund_coupon_title === 'string';
        const hasCharged = (
            rentalDetail.payment_sub_total > 0 && rentalDetail.payment_status === PAYMENT_STATUS_SUCCESS
        );

        return (
            <AuthView className="rental rental-detail">
                <Smart
                    fetch={ this.fetchData }
                    pauseRefresh
                    seamless
                >
                    <NavigationBar title={ this.rentalId } sticky>
                        <FunctionButtons
                            disabledChangeAmount={ rentalDetail.payment_status !== PAYMENT_STATUS_FAIL }
                            disabledRefund={ refunded || !hasCharged }
                            onSelectRefundType={ this.handleRefundTypeSelect }
                            onOpenChangeAmountModal={ () => this.setState({ showChangeAmountModal: true }) }
                        />
                    </NavigationBar>
                    <RefundModal
                        show={ showRefundModal }
                        type={ refundType }
                        charged={ rentalDetail.payment_sub_total }
                        onClose={ () => this.setState({ showRefundModal: false }) }
                        onSubmit={ this.handleRefundSubmit }
                    />
                    <ConfirmModal
                        title={ I18n.t('rental.refund_confirm') }
                        show={ showRefundConfirmModal }
                        caption={ I18n.t('rental.refunded') }
                        value={ parseInt(refundValue) }
                        onClose={ () => this.setState({ showRefundConfirmModal: false }) }
                        onSubmit={ this.handleRefundConfirmSubmit }
                    />
                    <ChangeAmountModal
                        show={ showChangeAmountModal }
                        type={ refundType }
                        discount={ rentalDetail.discount }
                        subTotal={ rentalDetail.sub_total }
                        onClose={ () => this.setState({ showChangeAmountModal: false }) }
                        onSubmit={ this.handleChangeAmountWarning }
                    />
                    <ConfirmModal
                        title={ I18n.t('rental.change_amount_confirm') }
                        show={ showChangeAmountConfirmModal }
                        caption={ I18n.t('rental.new_amount') }
                        value={ parseInt(newAmount) }
                        onClose={ () => this.setState({ showChangeAmountConfirmModal: false }) }
                        onSubmit={ this.handleChangeAmount }
                    />
                    <section className="form-container">
                        <FlexGroup spaceBetween>
                            <Translate value="customer.details" className="caption" tag="h2" />
                            <FlexGroup className="refresh-section">
                                <Refresh
                                    time={ rentalDetail.__responseTime }
                                    onClick={ this.fetchData }
                                />
                            </FlexGroup>
                        </FlexGroup>
                        <DetailsSection
                            data={ rentalDetail }
                            id={ this.rentalId}
                            onRefetch={ this.fetchData }
                        />
                    </section>
                </Smart>
            </AuthView>
        );
    }
}

export default connect((state, ownProps) => ({
    i18n: state.i18n,
    detail: state.rental.get('detail')[ownProps.match.params.rentalId],
}))(RentalDetail);
